// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchVariableList,
//   updateVariableList, clearSelectedVariableId 
// } from "../../../slices/panelSlice/variableListSlice";
// import Pagination from "../../../components/Pagination";
// import Loader from "../../../components/Loader";
// import EditableTable from "./VariableMapTable";
// import Modal from "../../../components/Modal";
// import ChangeLog from "../../../components/ChangeLog";
// import Swal from "sweetalert2";
// import api from "../../../auth/api";
// import { alertConfirm, alertSuccess } from "../../../components/Alert";
// import {
//   fetchSubCategoryData,
//   fetchVTypeData,
//   fetchCategoryData,
// } from "../../../slices/panelSlice";
// import AddVariable from "./AddVariable";
// import ViewSingleVariableList from "./SingleViewData/ViewSingleVariableList";
// import LargeModal from "@/components/LargeModal";

// function VariableMap({editable}) {
//   const dispatch = useDispatch();
//   const { variableList, status, error } = useSelector(
//     (state) => state.variableList
//   );
//   const { VTypeData, categoryData, subCategoryData } = useSelector(
//     (state) => state.panel
//   );
//  const [selectedViewId, setSelectedViewId] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [editRowId, setEditRowId] = useState(null);
//   const [editedData, setEditedData] = useState({});

//   const itemsPerPage = 10;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = Array.isArray(variableList?.QuestionList)
//     ? variableList?.QuestionList?.slice(indexOfFirstItem, indexOfLastItem)
//     : [];
//   const totalPages = Array.isArray(variableList?.QuestionList)
//     ? Math.ceil(variableList?.QuestionList?.length / itemsPerPage)
//     : 0;
//   const headers =
//     variableList?.QuestionList?.length > 0
//       ? Object.keys(variableList.QuestionList[0]).filter((key) => key !== "id")
//       : [];

//   const editableFields = [
//     "title",
//     "comment",
//     "optional",
//     "is_active",
//     "editable",
//     "variableType",
//     "category",
//     "subCategory",
//     "Question_title",
//     "Question_Subtitle",
//     "is_option",
//     "is_countryOption",
//   ]; // Define editable fields

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [currentLog, setCurrentLog] = useState([]);

//   const [viewData , setViewData] = useState([]);
//   const [isViewModalOpen, setIsViewModalOpen] = useState(false);

//   const [addDis, setAddDis] = useState(false);

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);


//   const openModalView = () => setIsViewModalOpen(true);
//   const closeModalView = () => setIsViewModalOpen(false);

//   useEffect(() => {
//     dispatch(fetchVariableList());
//     dispatch(fetchVTypeData());
//     dispatch(fetchCategoryData());
//     dispatch(fetchSubCategoryData());
//   }, [dispatch]);

//   const handleEdit = (rowId) => {
//     setEditRowId(rowId);
//     const rowData = variableList?.QuestionList.find(
//       (user) => user.id === rowId
//     );
//     setEditedData(rowData);
//   };

//   const handleSave = async () => {
//     const {
//       id,
//       title,
//       variableType,
//       category,
//       subCategory,
//       comment,
//       optional,
//       editable,
//       is_active,
//       Question_title,
//       Question_Subtitle,
//       is_countryOption,
//       is_option,
//     } = editedData;

//     const variableTypeId = VTypeData?.result?.filter(
//       (f) => f.title === variableType
//     )[0].id;
//     const categoryId = categoryData?.result?.filter(
//       (f) => f.title === category
//     )[0].id;
//     const subCategoryId = subCategoryData?.result?.filter(
//       (f) => f.title === subCategory
//     )[0].id;

//     const finalData = {
//       id,
//       title,
//       comment,
//       optional,

//       editable,
//       is_active,
//       is_countryOption,
//       is_option,

//       variableType: variableTypeId,
//       category: categoryId,
//       subCategory: subCategoryId,
//       QuestionTitle: {
//         title: Question_title,
//         subTitle: Question_Subtitle,
//       },
//     };


//     const resp = await dispatch(updateVariableList(finalData));
//     if (!resp.error) {
//       setEditRowId(null);
//       dispatch(fetchVariableList());
//     }
//   };

//   const handleAddVariable = () => {
//     setAddDis(true);
//   };

//   const handleCancel = () => {
//     setEditRowId(null);
//     setEditedData({});
//   };

//   const handleChange = (e, field, val) => {
//     if (
//       field === "is_active" ||
//       field === "editable" ||
//       field === "optional" ||
//       field === "is_option" ||
//       field === "is_countryOption"
//     ) {
//       setEditedData((prev) => ({
//         ...prev,
//         [field]: !val,
//       }));
//     } else {
//       setEditedData((prev) => ({
//         ...prev,
//         [field]: e.target.value,
//       }));
//     }
//   };

//   const handleLog = (id) => {
//     const logData = variableList.Change_Log.filter((f) => f.id === id)[0]
//       ?.oldTrack;
//     setCurrentLog(logData);
//     openModal();
//   };

//   const handleview = (id) => {
//         // const logData = variableList.QuestionList.filter((f) => f.id === id)
//           setViewData(id)
//           openModalView();
//   }


//   if (status === "loading") {
//     return (
//       <div className="w-full pt-20 flex justify-center">
//         <Loader />
//       </div>
//     );
//   }


//   return (
//     <div className="w-full flex items-center flex-col">
//       <div className="w-[95%]">
//         <EditableTable
//           headers={headers}
//           rows={currentItems}
//           editRowId={editRowId}
//           editedData={editedData}
//           handleEdit={handleEdit}
//           handleSave={handleSave}
//           handleCancel={handleCancel}
//           handleChange={handleChange}
//           handleLog={handleLog}
//           handleview={handleview}
//           editableFields={editableFields} // Pass editable fields
//           vTypeData={VTypeData}
//           categoryData={categoryData}
//           subCategoryData={subCategoryData}
//           editable={editable}
//         />
//       </div>

//       <div className="flex mt-4 items-center justify-between w-11/12">
//         <Pagination
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//           totalPages={totalPages}
//         />

//         {editable && 
//          <button
//           className="activeBtn text-sm text-white  py-1 px-2 rounded"
//           onClick={handleAddVariable}
//         >
//           + Add Variable
//         </button>
//         }

//       </div>

//       <Modal
//         isOpen={isModalOpen}
//         onClose={closeModal}
//         title="Change Log"
//         content={<ChangeLog data={currentLog} />}
//       />

//       <Modal
//         isOpen={addDis}
//         onClose={() => setAddDis(false)}
//         title="Add Variable"
//         content={
//           <AddVariable
//             vTypeData={VTypeData}
//             categoryData={categoryData}
//             subCategoryData={subCategoryData}
//           />
//         }
//       />

//        <LargeModal
//         isOpen={isViewModalOpen}
//         onClose={closeModalView}
//          onCloseExtra={() => dispatch(clearSelectedVariableId())}
//         title="View Variable"
//         content={<ViewSingleVariableList Id={viewData} 
//         onClose={closeModalView}
//         />
//       }
//       />
//     </div>
//   );
// }

// export default VariableMap;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchVariableList,
  updateVariableList,
  setSelectedVariableId,
  clearSelectedVariableId,
} from "../../../slices/panelSlice/variableListSlice";
import Pagination from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import EditableTable from "./VariableMapTable";
import Modal from "../../../components/Modal";
import ChangeLog from "../../../components/ChangeLog";
import Swal from "sweetalert2";
import api from "../../../auth/api";
import { alertConfirm, alertSuccess } from "../../../components/Alert";
import {
  fetchSubCategoryData,
  fetchVTypeData,
  fetchCategoryData,
} from "../../../slices/panelSlice";
import AddVariable from "./AddVariable";
import ViewSingleVariableList from "./SingleViewData/ViewSingleVariableList";
import LargeModal from "@/components/LargeModal";

function VariableMap({ editable }) {
  const dispatch = useDispatch();
  const { variableList, status, error } = useSelector(
    (state) => state.variableList
  );
  const { VTypeData, categoryData, subCategoryData } = useSelector(
    (state) => state.panel
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(variableList?.QuestionList)
    ? variableList?.QuestionList?.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Array.isArray(variableList?.QuestionList)
    ? Math.ceil(variableList?.QuestionList?.length / itemsPerPage)
    : 0;
  const headers =
    variableList?.QuestionList?.length > 0
      ? Object.keys(variableList.QuestionList[0]).filter((key) => key !== "id")
      : [];

  const editableFields = [
    "title",
    "comment",
    "optional",
    "is_active",
    "editable",
    "variableType",
    "category",
    "subCategory",
    "Question_title",
    "Question_Subtitle",
    "is_option",
    "is_countryOption",
  ]; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);

  const [viewData, setViewData] = useState([]);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const [addDis, setAddDis] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);


  const openModalView = () => setIsViewModalOpen(true);
  const closeModalView = () => {
    setIsViewModalOpen(false);
    dispatch(clearSelectedVariableId());
  };

  useEffect(() => {
    dispatch(fetchVariableList());
    dispatch(fetchVTypeData());
    dispatch(fetchCategoryData());
    dispatch(fetchSubCategoryData());
  }, [dispatch]);

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = variableList?.QuestionList.find(
      (user) => user.id === rowId
    );
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const {
      id,
      title,
      variableType,
      category,
      subCategory,
      comment,
      optional,
      editable,
      is_active,
      Question_title,
      Question_Subtitle,
      is_countryOption,
      is_option,
    } = editedData;

    const variableTypeId = VTypeData?.result?.filter(
      (f) => f.title === variableType
    )[0].id;
    const categoryId = categoryData?.result?.filter(
      (f) => f.title === category
    )[0].id;
    const subCategoryId = subCategoryData?.result?.filter(
      (f) => f.title === subCategory
    )[0].id;

    const finalData = {
      id,
      title,
      comment,
      optional,

      editable,
      is_active,
      is_countryOption,
      is_option,

      variableType: variableTypeId,
      category: categoryId,
      subCategory: subCategoryId,
      QuestionTitle: {
        title: Question_title,
        subTitle: Question_Subtitle,
      },
    };


    const resp = await dispatch(updateVariableList(finalData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchVariableList());
    }
  };

  const handleAddVariable = () => {
    setAddDis(true);
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field, val) => {
    if (
      field === "is_active" ||
      field === "editable" ||
      field === "optional" ||
      field === "is_option" ||
      field === "is_countryOption"
    ) {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  const handleLog = (id) => {
    const logData = variableList.Change_Log.filter((f) => f.id === id)[0]
      ?.oldTrack;
    setCurrentLog(logData);
    openModal();
  };

  const handleview = (id) => {
    const logData = variableList.QuestionList.filter((f) => f.id === id);
    dispatch(setSelectedVariableId(id));
    setViewData(logData);
    openModalView();
  };


  if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }


  return (
    <div className="w-full flex items-center flex-col">
      <div className="w-[95%]">
        <EditableTable
          headers={headers}
          rows={currentItems}
          editRowId={editRowId}
          editedData={editedData}
          handleEdit={handleEdit}
          handleSave={handleSave}
          handleCancel={handleCancel}
          handleChange={handleChange}
          handleLog={handleLog}
          handleview={handleview}
          editableFields={editableFields} // Pass editable fields
          vTypeData={VTypeData}
          categoryData={categoryData}
          subCategoryData={subCategoryData}
          editable={editable}
        />
      </div>

      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />

        {editable &&
          <button
            className="activeBtn text-sm text-white  py-1 px-2 rounded"
            onClick={handleAddVariable}
          >
            + Add Variable
          </button>
        }

      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog} />}
      />

      <Modal
        isOpen={addDis}
        onClose={() => setAddDis(false)}
        title="Add Variable"
        content={
          <AddVariable
            vTypeData={VTypeData}
            categoryData={categoryData}
            subCategoryData={subCategoryData}
          />
        }
      />

      <LargeModal
        isOpen={isViewModalOpen}
        onClose={closeModalView}
        title="View Variable"
        content={<ViewSingleVariableList data={viewData}
          onClose={closeModalView}
        />
        }
      />
    </div>
  );
}

export default VariableMap;